export interface InsidePage {
  src: string
  alt: string
  caption: string
}

export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/71M8Qtdhm8deoB8CkB46BQ/Captura_de_pantalla_2026-09-07_a_la(s)_3.53.49_p._m..png',
    alt: '30-minute lower body strength class sheet with six visual exercises, rep counts, coaching notes and required equipment',
    caption: '30-Min Lower Body Strength — visual class sheet',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cxPLyeW2T6ixCn3rtmrJAt/Captura_de_pantalla_2026-09-07_a_la(s)_3.54.03_p._m..png',
    alt: '45-minute mixed confidence class showing a seated chair block, transition and standing block with equipment and class flow diagrams',
    caption: '45-Min Chair to Standing — full class structure',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/19gXkS8EqiXoCAr8YTBCfW/Captura_de_pantalla_2026-09-07_a_la(s)_3.54.47_p._m..png',
    alt: 'Outdoor walk and strength 30-minute circuit map with three strength stops along a park route',
    caption: 'Outdoor Walk + Strength — circuit route map',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wujezv9a85YbbKeYG6VgCz/Captura_de_pantalla_2026-09-07_a_la(s)_3.55.49_p._m..png',
    alt: '45-minute active aging session with a phase timeline and six visual exercises across warm-up, strength, functional, balance and mobility',
    caption: '45-Min Active Aging — phased session plan',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wA3aEgMrGrPs5N3dWjkPLA/Captura_de_pantalla_2026-09-07_a_la(s)_3.56.17_p._m..png',
    alt: 'Active aging circuit with six numbered training stations, work and transition timings and round count',
    caption: 'Active Aging Circuit — 6 training stations',
  },
]
